import React from "react";

import { TimeDiff } from "components/common/Time";

const Photo = ({ narrowLayout, onPhotoChange, photo, photos }) => {
  const onClick = () => onPhotoChange(photos.indexOf(photo));

  // Support 'narrowLayout' mode for locatons such as the Event Page, where
  // the photo gallery is limited in width. Otherwise, pages such as the
  // gallery page will use the full screen layout.
  const columns = narrowLayout ? "col-md-4 col-sm-6 col-xs-6" : "col-md-3 col-sm-4 col-xs-6";

  return (
    <div className="gallery-photo" onClick={onClick}>
      <div className={`gallery-photo__fader ${columns}`}>
        <div
          className="gallery-photo__front"
          style={{ backgroundImage: `url(${photo.image.mediumUrl})` }}
        />
        <div className="gallery-photo__back">
          <div className="gallery-photo__metadata">
            <span>{photo.event.name}</span>
            <h5>
              <TimeDiff time={photo.createdAt} />
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Photo;
